/** mt-card-list **/
Array.from(document.querySelectorAll(".mt-card-list__container")).forEach((container) => {
    const inner = container.querySelector(".mt-card-list__inner");
    let isClicked = false;
    let maxWidth = inner.getBoundingClientRect().left + inner.getBoundingClientRect().width;                                                                                                                                                                                                               
    container.querySelector(".slider-button--prev").addEventListener('click', (e) => {
        if(isClicked) return;
        isClicked = true;
        let val = parseInt(inner.getAttribute("data-val"));
        if(val > 1){                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  
          val = parseInt(val) - 1;          
          selectContent(val);
        }else{
          isClicked = false;
        }
    });
    container.querySelector(".slider-button--next").addEventListener('click', (e) => {
        if(isClicked) return;
        isClicked = true;
        let val = parseInt(inner.getAttribute("data-val"));
        let maxVal = parseInt(inner.getAttribute("data-max-val"));
        let itemWidth = itemSelects[itemSelects.length -1].getBoundingClientRect().width;
        let width = itemWidth + itemSelects[itemSelects.length -1].getBoundingClientRect().left;
        if(val < maxVal && width > (maxWidth + itemWidth) ){
          val = val + 1;
          selectContent(val);
        }else{
          isClicked = false;
        }
    });
    let itemSelects = Array.from(container.querySelectorAll(".mt-card-list__item"));
    let firstLeft = itemSelects[0].offsetLeft;
    let leftX = itemSelects[1].offsetLeft - itemSelects[0].offsetLeft;  
    function selectContent(val){ 
      let moveX = 0;
      if(itemSelects != null && itemSelects.length > 1){
        moveX = 0 - leftX * (val - 1);
      }
      inner.scrollLeft = -moveX;
      inner.setAttribute("data-val", val);
      isClicked = false;
    }
});
/** mt-card-list **/
/** mt-image-text-list **/
Array.from(document.querySelectorAll(".mt-image-text-list__container")).forEach(
  (container) => {
    let dots = container.querySelector(".dots");
    let itemSelects = Array.from(
      container.querySelectorAll(".mt-image-text-list__item")
    );
    if (dots != null && itemSelects != null) {
      Array.from(dots.querySelectorAll(".dot")).forEach((dot) => {
        dot.addEventListener("click", (e) => {
          let val = parseInt(e.target.getAttribute("data-val"));
          selectContent(parseInt(val));
        });
      });

      let leftX = 0;
      if (itemSelects.length > 1) {
        leftX = itemSelects[1].offsetLeft - itemSelects[0].offsetLeft;
      }
      function selectContent(val) {
        let moveX = 0;
        if (itemSelects != null && itemSelects.length > 1) {
          moveX = 0 - leftX * (val - 1);
        }
        container.querySelector(".mt-image-text-list__inner").scrollLeft = -moveX;
        Array.from(dots.querySelectorAll(".dot")).forEach((item) => {
          if (parseInt(item.getAttribute("data-val")) == val) {
            item.classList.add("selected");
          } else {
            item.classList.remove("selected");
          }
        });
        itemSelects.forEach((item) => {
          if (parseInt(item.getAttribute("data-val")) == val) {
            item.classList.add("selected");
          } else {
            item.classList.remove("selected");
          }
        });
        curIndex = val;
      }
    }
  }
);
/** mt-image-text-list **/

/** image-with-text-overlay **/
Array.from(document.querySelectorAll(".company_window_wrapper")).forEach(
  (container) => {
    let dots = container.querySelector(".dots");
    let itemSelects = Array.from(
      container.querySelectorAll(".company_window_item")
    );
    if (dots != null && itemSelects != null) {
      Array.from(dots.querySelectorAll(".dot")).forEach((dot) => {
        dot.addEventListener("click", (e) => {
          let val = parseInt(e.target.getAttribute("data-val"));
          selectContent(parseInt(val));
        });
      });

      let leftX = 0;
      if (itemSelects.length > 1) {
        leftX = itemSelects[1].offsetLeft - itemSelects[0].offsetLeft;
      }
      function selectContent(val) {
        let moveX = 0;
        if (itemSelects != null && itemSelects.length > 1) {
          moveX = 0 - leftX * (val - 1);
        }
        container.querySelector(".company_window_items").scrollLeft = -moveX;
        Array.from(dots.querySelectorAll(".dot")).forEach((item) => {
          if (parseInt(item.getAttribute("data-val")) == val) {
            item.classList.add("selected");
          } else {
            item.classList.remove("selected");
          }
        });
        itemSelects.forEach((item) => {
          if (parseInt(item.getAttribute("data-val")) == val) {
            item.classList.add("selected");
          } else {
            item.classList.remove("selected");
          }
        });
        curIndex = val;
      }
    }
  }
);
/** image-with-text-overlay **/